/**
 * Used to determine the fitting font size for header text based on its width.
 */
; window.fitHeaderText = (() => {

    function getTextWidth(text, font) {
        const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
    };

    function getFittingFontSize(text) {
        const fontsizes = {
            24: 'text-2xl',
            20: 'text-xl',
            18: 'text-lg'
        };
        let maxFittingSize = Object.keys(fontsizes)
            .sort().reverse()
            .find(size => getTextWidth(text, size+"pt serif") < window.innerWidth);
        return fontsizes[maxFittingSize ? maxFittingSize : 18]
    }

    return {
        getFittingFontSize,
    }

})()
